import script from "./TheFlashMessages.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheFlashMessages.vue?vue&type=script&lang=ts&setup=true"

import "./TheFlashMessages.vue?vue&type=style&index=0&id=54e6ddaf&scoped=true&lang=css"

import exportComponent from "/builds/n-Zh5gRSP/0/batesbus/app.securechannel.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e6ddaf"]])

export default __exports__